import styled from 'styled-components'
import { Container } from './Container'
import { Truncate, TruncatePreset, TTruncateMixin } from '../styles/mixins'

export const EllipsisContainer = styled(Container)<TTruncateMixin>`
  ${TruncatePreset('100%')};
  ${(props: TTruncateMixin) => Truncate({ ...props })};
`
